import{useState as r,useEffect as o}from"react";function n({url:n}){const[t,e]=r(!1);return o((()=>{if(!n)return e(!1);const r=new Image;r.onload=()=>e(!0),r.onerror=()=>e(!1),r.src=n}),[n]),t}export{n as default};
